/**
 * ProDesignProjects Queries
 */

import gql from 'graphql-tag'

export const getHomepageInfo = gql`
  query getHomepageContent($sportRoute: String) {
    getHomepageContent(sportRoute: $sportRoute) {
      mainHeaderImages {
        id
        desktopImage: image
        mobileImage: image_mobile
        url: link
        assetType: type
      }
      carouselSettings {
        slideTransition: slide_transition
        slideDuration: slide_duration
        secondarySlideTransition: secondary_slide_transition
        secondarySlideDuration: secondary_slide_duration
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProDesignProjectsAbout/data.ts